import { render } from "./PlayerResults.vue?vue&type=template&id=c64d03dc&scoped=true"
import script from "./PlayerResults.vue?vue&type=script&lang=js"
export * from "./PlayerResults.vue?vue&type=script&lang=js"

import "./PlayerResults.vue?vue&type=style&index=0&id=c64d03dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64d03dc"]])

export default __exports__